// list of uoms that shouldn't handle decimals
export const QUANTITY_DECIMALS_NOT_ALLOWED = ['ea', 'gm', 'hd']